import React, { PureComponent } from "react";
import { Form, Row, Col } from "antd";
import "./forms.css";
import PhoneNumberMask from "../../../../../../common/inputs/AuthorizationInputs";

import {
  Name,
  LastName,
  Patronymic,
  SubjectId,
  DateBirth,
  DocumentSeries,
  DocumentNumber,
  PhoneCode,
  // PhoneNumber,
  Email,
  BankName,
  Bik,
  Сorrespondent,
  BankAccount
} from "./fieldsConfig";

class RequisitesFormFIZ extends PureComponent {
  numberToYears = number => {
    number = Math.abs(number) % 100;

    const numberOne = number % 10;

    if (number > 10 && number < 20) {
      return "лет";
    }

    if (numberOne > 1 && numberOne < 5) {
      return "года";
    }

    if (numberOne === 1) {
      return "год";
    }
    return "лет";
  };

  render() {
    let { company, request } = this.props;
    let getFieldDecorator = this.props.decorator;

    const differenceBetweenDate =
      new Date().getFullYear() - new Date(company.birthDate).getFullYear();
    const dateText = this.numberToYears(differenceBetweenDate);

    return (
      <div className="requestCardForm">
        <Form>
          <Row
            type="flex"
            align="middle"
            className="formRow mb-large"
            gutter={16}
          >
            <Col span={6} className="formCol right">
              <span className="label">Субъект заказчика:</span>
            </Col>
            <Col className="formCol">
              <SubjectId
                val={company.subjectId.subject}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Фамилия:</span>
            </Col>
            <Col span={12} className="formCol">
              <LastName
                val={company.lastname}
                decorator={getFieldDecorator}
                classes="short"
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Имя:</span>
            </Col>
            <Col span={12} className="formCol">
              <Name
                val={company.name}
                decorator={getFieldDecorator}
                classes="short"
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Отчество:</span>
            </Col>
            <Col span={12} className="formCol">
              <Patronymic
                val={company.patronymic}
                decorator={getFieldDecorator}
                classes="short"
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Дата рождения:</span>
            </Col>
            <Col span={7} className="formCol">
              <DateBirth
                val={
                  company.birthDate
                    ? new Date(company.birthDate).toLocaleDateString()
                    : "Не указано"
                }
                decorator={getFieldDecorator}
                classes="short"
                disabled
              />
            </Col>
            {company.birthDate ? (
              <Col span={6} className="formCol">
                <span>{`${differenceBetweenDate} ${dateText}`}</span>
              </Col>
            ) : null}
          </Row>
          {company.birthPlace && (
            <Row type="flex" align="middle" className="formRow" gutter={16}>
              <Col span={6} className="formCol right">
                <span className="label">Место рождения:</span>
              </Col>
              <Col span={12} className="formCol">
                <DocumentSeries
                  val={company.birthPlace}
                  decorator={getFieldDecorator}
                  classes="long"
                  disabled
                />
              </Col>
            </Row>
          )}
          {company.passportSeries && (
            <Row type="flex" align="middle" className="formRow" gutter={16}>
              <Col span={6} className="formCol right">
                <span className="label">Серия паспорта:</span>
              </Col>
              <Col span={12} className="formCol">
                <DocumentSeries
                  val={company.passportSeries}
                  decorator={getFieldDecorator}
                  classes="short"
                  disabled
                />
              </Col>
            </Row>
          )}
          {company.passportNumber && (
            <Row type="flex" align="middle" className="formRow" gutter={16}>
              <Col span={6} className="formCol right">
                <span className="label">Номер паспорта:</span>
              </Col>
              <Col span={12} className="formCol">
                <DocumentNumber
                  val={company.passportNumber}
                  decorator={getFieldDecorator}
                  classes="short"
                  disabled
                />
              </Col>
            </Row>
          )}
          <Row
            type="flex"
            align="middle"
            className="formRow double-margin"
            gutter={16}
          >
            <Col span={6} className="formCol right">
              <span className="label">Номер телефона:</span>
            </Col>
            <Col span={12} className="formCol">
              <PhoneCode
                val={company.phoneCode}
                // val={company.phoneCode}
                decorator={getFieldDecorator}
                classes="small mr"
                disabled
              />
              {/*<PhoneNumber
                val={company.phone}
                decorator={getFieldDecorator}
                classes="short"
                disabled
              />*/}
              <PhoneNumberMask
                autoComplete="off"
                className="short"
                name="phone"
                mask="(###) ###-##-##"
                value={company.phone}
                maxLength={15}
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">E-mail:</span>
            </Col>
            <Col span={12} className="formCol">
              <Email
                val={
                  request && request.profileId && request.profileId.userId
                    ? request.profileId.userId.email
                    : company.email
                    ? company.email
                    : null
                }
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          {company.bankAccount &&
            company.bankAccount.map((item, index) => (
              <div key={"bankAccount" + index}>
                <Row
                  type="flex"
                  align="middle"
                  className="formRow"
                  key={"bankName" + index}
                  gutter={16}
                >
                  <Col span={6} className="formCol right">
                    <span className="label">Наименование банка:</span>
                  </Col>
                  <Col span={12} className="formCol">
                    <BankName
                      val={item.bankName}
                      index={index}
                      decorator={getFieldDecorator}
                      classes="long"
                      disabled
                    />
                  </Col>
                </Row>
                <Row
                  type="flex"
                  align="middle"
                  className="formRow"
                  key={"bik" + index}
                  gutter={16}
                >
                  <Col span={6} className="formCol right">
                    <span className="label">БИК:</span>
                  </Col>
                  <Col span={12} className="formCol">
                    <Bik
                      val={item.bik}
                      index={index}
                      decorator={getFieldDecorator}
                      classes="short"
                      disabled
                    />
                  </Col>
                </Row>
                <Row
                  type="flex"
                  align="middle"
                  className="formRow"
                  key={"accountCorr" + index}
                  gutter={16}
                >
                  <Col span={6} className="formCol right">
                    <span className="label">Корреспондентский счет:</span>
                  </Col>
                  <Col span={12} className="formCol">
                    {/* eslint-disable-next-line react/jsx-pascal-case */}
                    <Сorrespondent
                      val={item.accountCorr}
                      index={index}
                      decorator={getFieldDecorator}
                      classes="short"
                      disabled
                    />
                  </Col>
                </Row>
                <Row
                  type="flex"
                  align="middle"
                  className={
                    index !== company.bankAccount.length - 1
                      ? "formRow mb-large"
                      : "formRow"
                  }
                  key={"bankAccountNum" + index}
                  gutter={16}
                >
                  <Col span={6} className="formCol right">
                    <span className="label">Расчетный счет:</span>
                  </Col>
                  <Col span={12} className="formCol">
                    <BankAccount
                      val={item.bankAccountNum}
                      index={index}
                      decorator={getFieldDecorator}
                      classes="short"
                      disabled
                    />
                  </Col>
                </Row>
              </div>
            ))}{" "}
        </Form>
      </div>
    );
  }
}

export default RequisitesFormFIZ;
